import { render, staticRenderFns } from "./CalendarMonteIABeta.vue?vue&type=template&id=658cd920&"
import script from "./CalendarMonteIABeta.vue?vue&type=script&lang=js&"
export * from "./CalendarMonteIABeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports